import React, { useState, useEffect, useRef } from 'react';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import Header from '../common/template/header';
import Footer from '../common/template/footer';
import Routes from './routes';
import AdSense from 'react-adsense';
import { getCachedCountry, detectCountry, isRussianCountry } from '../common/geoTargeting';
import { RussianAdBanner, RussianSideRails, RussianSocialBar } from '../common/RussianAds';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCAFkB1_9OqLnHziPC_BIm6Gp7N_nr_0FI",
    authDomain: "textcaseconvert-3679c.firebaseapp.com",
    projectId: "textcaseconvert-3679c",
    storageBucket: "textcaseconvert-3679c.appspot.com",
    messagingSenderId: "109555819996",
    appId: "1:109555819996:web:5f311997f50664ad5cdb19",
    measurementId: "G-JTRDXLBDRD"
};

const attachScript = (src, attrs = {}) => {
    return new Promise((resolve) => {
        if (typeof document === 'undefined') return resolve(null);
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) return resolve(existing);

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        Object.keys(attrs).forEach(key => {
            script[key] = attrs[key];
        });

        script.onload = () => resolve(script);
        script.onerror = () => resolve(null);

        document.head.appendChild(script);

        // In test environments (like jsdom), trigger onload asynchronously
        if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
            setTimeout(() => {
                if (script.onload) script.onload();
            }, 10);
        }
    });
};

const App = props => {
    // Initialize Firebase safely
    try {
        const firebaseApp = initializeApp(firebaseConfig);
        if (firebaseApp && firebaseApp.name && typeof window !== 'undefined') {
            getAnalytics(firebaseApp);
        }
    } catch (e) {
        // Ignore duplicate app initialization in test/SSR
    }

    const [country, setCountry] = useState(getCachedCountry);
    const [adsReady, setAdsReady] = useState(false);

    const isRussia = isRussianCountry(country);

    useEffect(() => {
        let isMounted = true;
        detectCountry().then(code => {
            if (isMounted) {
                setCountry(code);
            }
        }).catch(() => {
            if (isMounted) {
                setCountry('UNKNOWN');
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        if (country === null) return;

        if (isRussia) {
            // Ensure no Google AdSense scripts are loaded for Russia
            if (typeof document !== 'undefined') {
                const existingGoogle = document.querySelectorAll('script[src*="pagead2"], script[src*="adsbygoogle"]');
                existingGoogle.forEach(s => s.remove());
            }
            return;
        }

        // For all other countries: load Google AdSense script
        if (typeof window !== 'undefined' && !window.__adScriptsLoaded__) {
            window.__adScriptsLoaded__ = true;
            attachScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2605486701851317', {
                crossOrigin: 'anonymous'
            }).then(() => {
                window.adsbygoogle = window.adsbygoogle || [];
                setAdsReady(true);
            });
        } else if (typeof window !== 'undefined' && window.__adScriptsLoaded__) {
            setAdsReady(true);
        }
    }, [country, isRussia]);

    return (
        <React.Fragment>
            <Header />
            {isRussia && <RussianSideRails />}
            {isRussia && <RussianSocialBar />}
            <main role="main" className="flex-shrink-0">
                <div className="container mt-5">
                    {/* // auto full width responsive ads or Russian ad network */}
                    {isRussia ? (
                        <RussianAdBanner />
                    ) : adsReady ? (
                        <AdSense.Google
                            client='ca-pub-2605486701851317'
                            slot='4801753310'
                            style={{ display: 'block' }}
                            format='auto'
                            responsive='true'
                            layoutKey='-gw-1+2a-9x+5c'
                        />
                    ) : (
                        <div className="ad-element-top-placeholder" style={{ minHeight: '100px' }} aria-hidden="true" />
                    )}
                    <Routes />
                </div>
            </main>
            <Footer />
        </React.Fragment>
    );
};

export { RussianAdBanner, RussianSideRails, RussianSocialBar };
export default App;